import { IPaymentBillPageParams, IPaymentFundCount, IPaymentFundPageParams, IPaymentReceiptPageParams } from '../../../../types/lianlian-manage';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 分账账户 - 收款方管理交易记录分页
 */
export async function queryPayeeFundPageList(params) {
  let data = [];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: []; total: number}>(`${hostUrl}/pay/payee/fund/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: []; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 *  空中分账 - 分账账户 - 付款方管理交易记录统计
 */

export async function queryPayeeFundCount(params: IPaymentFundPageParams) {
  let data = {} as IPaymentFundCount;

  try {
    const { code, context, message } = await Http.get<IPaymentFundCount>(`${hostUrl}/pay/payee/fund/count`, params);

    if (code === EAxiosResponseCode.Succeed) {

      data = context || {} as IPaymentFundCount;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 *  空中分账 - 分账账户 - 付款方管理交易记录分页导出
 */

export async function exportPayeeFundPage(params) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/pay/payee/fund/export`,
      { ...params },
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 空中分账 - 分账账户 - 收款方管理回单分页
 */
export async function queryPayeeReceiptPageList(params) {
  let data = [];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: []; total: number}>(`${hostUrl}/pay/payee/receipt/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: []; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 *  空中分账 - 分账账户 - 收款方管理回单分页导出
 */

export async function exportPayeeReceiptPage(params: IPaymentReceiptPageParams) {
  let data = '' as string | null;

  try {
    const { code, context, message } = await Http[__ENABLE_DEV_MOCK__ || __MOCK_PROD__ ? 'get' : 'post']<any>(
      `${hostUrl}/pay/payee/receipt/batch-download`,
      { ...params },
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 分账账户 - 收款方管理提现记录
 */
export async function queryPayeeCashPageList(page: number, size: number, lianId: string) {
  let data = [];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: []; total: number}>(`${hostUrl}/pay/payee/cash/page`, {
      page,
      size,
      lianId,
    });

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: []; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 分账账户 - 收款方管理提现记录导出
 */

export async function exportPayeeCashPage(params) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/pay/payee/cash/export`,
      { ...params },
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

export async function tryWithdrawPayee(cashNo) {

  try {
    const { code, message } = await Http.post<any>(
      `${hostUrl}/pay/payee/cash/withdraw/${cashNo}`,

    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 空中分账 - 分账账户 - 收款方管理对账单
 */
export async function queryPayeeBillPageList(params?: IPaymentBillPageParams) {
  let data = [];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: []; total: number}>(`${hostUrl}/pay/payee/bill/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: []; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 分账账户 - 收款方管理对账单导出
 */

export async function exportPayeeBillPage(params?: IPaymentBillPageParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/pay/payee/bill/export`,
      { ...params },
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}
